/**
 * vue-amap 0.5.x 依赖已在 JSAPI 2.0 中移除的 AMap.event。
 * 在 SDK 就绪后补齐 addListener / removeListener，避免自定义地图等 2.0 能力无法使用。
 */
export function polyfillAMapEvent() {
  if (typeof window === "undefined" || !window.AMap) return;
  if (window.AMap.event && typeof window.AMap.event.addListener === "function") {
    return;
  }

  window.AMap.event = {
    addListener(instance, eventName, handler, context) {
      const bound = context ? handler.bind(context) : handler;
      instance.on(eventName, bound);
      return { instance, eventName, handler: bound };
    },
    addListenerOnce(instance, eventName, handler, context) {
      const bound = context ? handler.bind(context) : handler;
      const wrapper = (...args) => {
        instance.off(eventName, wrapper);
        bound(...args);
      };
      instance.on(eventName, wrapper);
      return { instance, eventName, handler: wrapper };
    },
    removeListener(listener) {
      if (!listener || !listener.instance) return;
      listener.instance.off(listener.eventName, listener.handler);
    },
    trigger(instance, eventName, args) {
      instance.emit(eventName, args);
    },
  };
}
